
import { Mixins, Component } from 'vue-mixin-decorator';

import StepTechModelMixin from '@/mixins/reviews/create/step-tech-model';

@Component
export default class StepTechModel extends Mixins<StepTechModelMixin>(StepTechModelMixin) {}
